import axiosClient from '../configs/axios.js';

class DeliveryEntryService {
  async getDeliveryEntryList(params) {
    try {
      const response = await axiosClient.get(
        `/deliveryentry/list`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }


  // async getDeliveryChallanList(params) {
  //   try {
  //     const response = await axiosClient.get(
  //       `/delivery-challan/list`
  //     );
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // }
async getDeliveryChallanList(customer_id) {
    try {
        if (!customer_id || customer_id === 'undefined') {
            throw new Error('Invalid customer_id provided');
        }
        const queryParams = new URLSearchParams({ customer_id }).toString();
            console.log("API Call URL:", `/deliveryentry/challanNo?${queryParams}`); // Debug URL
            const response = await axiosClient.get(`/deliveryentry/challanNo?${queryParams}`);
            console.log("API Response:", response.data); // Debug response
            return response.data;
        } catch (error) {
            console.error("Error fetching delivery challans:", error.message);
            throw error;
        }
      }

// ✅ Fetches ALL pending challans (no customer filter) — used when Challan No is the primary selector
async getAllChallanList(depot_id) {
  try {
    const queryParams = depot_id ? `?depot_id=${depot_id}` : '';
    const response = await axiosClient.get(`/deliveryentry/challanNo${queryParams}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all delivery challans:", error.message);
    throw error;
  }
}


// async getDeliveryChallanList(driver_id) {
//   try {
//     const response = await axiosClient.get(`/delivery-challan/list`);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching delivery challans:", error.message);
//     throw error;
//   }
// }

  async addDeliveryEntry(formData) {
    try {
      const response = await axiosClient.post('/deliveryentry/add', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // Add Authorization header if needed
          // 'Authorization': `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error in addDeliveryEntry:', error);
      throw error;
    }
  }

  async editDeleteDeliveryEntry(formData) {
    try {
      const response = await axiosClient.put('/deliveryentry/editDelete', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // Add Authorization header if needed
          // 'Authorization': `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error in editDeleteDeliveryEntry:', error);
      throw error;
    }
  }



}

export default new DeliveryEntryService();